import { render, staticRenderFns } from "./orderProductModal.vue?vue&type=template&id=47cbfb17&scoped=true"
import script from "./orderProductModal.vue?vue&type=script&lang=js"
export * from "./orderProductModal.vue?vue&type=script&lang=js"
import style0 from "./orderProductModal.vue?vue&type=style&index=0&id=47cbfb17&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cbfb17",
  null
  
)

export default component.exports